<template>
  <div class="repair">
    <!-- <MainTopNav></MainTopNav> -->
    <van-tabs color="#45a4b6" title-active-color="#fff" line-width="90" border v-model="activeName" swipeable animated>
      <van-tab title-style="border-right:1px solid #c9c9c9;" v-for="tab in tabs" :key="tab.id">
        <template #title>
          <!-- <div class="f-16" style="line-height:100%; margin-top:5px; ">{{tab.title.cn}}
          <br><span class="f-12">{{tab.title.en}}</span>
          </div>-->
          {{tab.name}}
        </template>

        <template>
          <van-grid :border="false">
            <van-grid-item v-for="brand in tab.children" :key="brand.id" :to="'/repair/'+brand.type+'/'+brand.id">
              <van-image radius="5" :src="global.getStaticFilePath(brand.picUrl,'/wx')" />
              <div class="f-12">{{brand.name}}</div>
            </van-grid-item>
          </van-grid>
        </template>
      </van-tab>
    </van-tabs>
    <MainMenuNav />
  </div>
</template>

<script>
import { Tab, Tabs, Image as VanImage, Lazyload, Grid, GridItem } from "vant";
import MainTopNav from "@/components/MainTopNav.vue";
import MainMenuNav from "@/components/MainMenuNav.vue";
import { Get_Brand_Tree } from "@/api/index";

export default {
  name: "RepairIndex",
  components: {
    MainTopNav,
    MainMenuNav,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [Lazyload.name]: Lazyload,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  data() {
    return {
      activeName: "a",
      company: {},
      params: {
        type: this.$route.params.type,
      },
      tabs: [],
    };
  },
  methods: {
    async getBrandTree() {
      this.params.regionType = this.company.type;
      this.tabs = await Get_Brand_Tree(this.params);
    },
  },
  mounted() {
    this.global.getMemberSystem().then((memberSystem) => {
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
        this.getBrandTree();
      }
    });
  },
  watch: {
    $route(to, from) {
      this.params.type = this.$route.params.type;
      this.getBrandTree();
    },
  },
};
</script>
